import { ErrorMessage, Field, useFormikContext } from 'formik'

import TfUser from 'jsx:/assets/ic_tf_user.svg'
import classNames from 'classnames'
import { FormLabel } from '../genericComponents/layout/FormLabel'

export const InputUsernameLogin: React.FC<{
  type?: string
  label?: string
  placeholder?: string
  name: string
  className?: string
  classNameForInput?: string
  disabled?: boolean
  autocompleteOff?: boolean
}> = (props) => {
  const { values } = useFormikContext()
  const value = getValueByName(props.name, values)

  return (
    <div className={props.className}>
      {props.label && <FormLabel>{props.label}</FormLabel>}
      <div className="flex row items-center no-wrap w-full">
        <div className="left-0 top-2 p-2 text-gray-400 transition duration-300">
          <TfUser />
        </div>
        <Field
          type={props.type}
          name={props.name}
          className={classNames(
            props.classNameForInput,
            `text-sm pl-2 h-12 my-2 w-full softlock-new outline-none
            border-borderColor border-b-2 focus:border-primaryAccentColor`
          )}
          value={value || ''}
          placeholder={props.placeholder}
          {...(props.disabled ? { disabled: true } : {})}
          autoComplete={props.autocompleteOff ? 'off' : ''}
        />

        <div className="w-6 "></div>
        <p></p>
      </div>
      <ErrorMessage className="text-alertColor" name={props.name} component="div" />
    </div>
  )
}

export const getValueByName = (name: string, values: unknown) => {
  //formik uses dot notation in field names for accessing nested values
  //break name on dots to get separate property keys
  const propertyKeys = name.split('.')
  let value = values
  propertyKeys.forEach((key) => {
    value = (value as Record<string, unknown>)[key] ?? ''
  })
  return value
}
